/* eslint-disable no-return-await,react/destructuring-assignment,react/prop-types, max-len */
// Copyright (c) 2019 Deere & Company

import './text-dropdown.scss';
import React, { Component } from 'react';
import { DropdownPopover } from './dropdown-popover';
import { Overlay } from 'react-overlays';
import PropTypes from 'prop-types';

export class TextDropdown extends Component {

    state = {
        showOverlay: false,
    };

    displayOverlay = () => this.setState({ showOverlay: true });

    hideOverlay = () => this.setState({ showOverlay: false });

    logout = async () => await this.props.auth.logout();

    render() {

        const arrowClass = this.state.showOverlay ? 'popover-caret with-arrow' : 'popover-caret';
        return (
            <div className="text-dropdown">
                <div className="text-display" onClick={this.displayOverlay}>
                    <span className="dropdown-text">{this.props.text}</span>
                    <span className={arrowClass} />
                </div>
                <Overlay container={this} onHide={this.hideOverlay} rootClose show={this.state.showOverlay}>
                    {() => <DropdownPopover onMenuItemClick={this.hideOverlay} logout={this.logout}>{this.props.children}</DropdownPopover>}
                </Overlay>
            </div>
        );

    }

}

TextDropdown.propTypes = {
    text: PropTypes.string.isRequired,
    children: PropTypes.node,
};
